export default __webpack_public_path__ + "static/media/Hello1.bb90dfb5.mp3";